var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard001(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 785.66 587.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #6543fa;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3, .cls-5, .cls-4 {\n        stroke-width: 5.17px;\n      }\n\n      .cls-2, .cls-3, .cls-6, .cls-5, .cls-4 {\n        stroke: #2d2165;\n      }\n\n      .cls-2, .cls-6 {\n        stroke-width: 12.92px;\n      }\n\n      .cls-7 {\n        fill: #6543fa;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-9, .cls-6, .cls-5 {\n        fill: #2d2165;\n      }\n\n      .cls-10 {\n        fill: #2d2165;\n      }\n\n      .cls-4 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-11 {\n        fill: #fcfdfd;\n      }\n\n      .cls-12 {\n        fill: #94d8f4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 176.76,
    cy: 552.47,
    rx: 128.98,
    ry: 34.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M629.24,514.79c11.09,2.62,22.22-4.2,24.94-15.27l80.96-330.36c1.79-7.3-1.81-14.46-8.03-15.98L145.49,12.53c-6.23-1.53-12.73,3.15-14.52,10.45L50.09,352.98c-2.75,11.21,4.17,22.51,15.41,25.16l563.74,136.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.75,49.38c-.98,3.98-5,6.42-8.98,5.44-3.98-.98-6.42-5-5.45-8.98.98-3.98,5-6.42,8.98-5.44,3.99.98,6.42,5,5.45,8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M187.94,54.57c-.98,3.98-5,6.42-8.98,5.44-3.98-.98-6.42-5-5.44-8.98.98-3.98,4.99-6.42,8.98-5.45,3.98.98,6.42,5,5.45,8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.12,59.77c-.98,3.98-5,6.42-8.98,5.45-3.98-.98-6.42-5-5.45-8.98.98-3.98,5-6.42,8.98-5.44,3.98.98,6.42,5,5.44,8.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 653.6,
    y1: 158.02,
    x2: 649.55,
    y2: 174.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 659.84,
    y1: 168.32,
    x2: 643.3,
    y2: 164.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "677.4 163.29 675.75 170.01 682.47 171.66 684.12 164.94 677.4 163.29 677.4 163.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "674.73 174.18 673.08 180.89 679.8 182.54 681.45 175.82 674.73 174.18 674.73 174.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "688.38 165.99 686.73 172.7 693.45 174.35 695.1 167.63 688.38 165.99 688.38 165.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "685.71 176.87 684.06 183.59 690.78 185.23 692.43 178.51 685.71 176.87 685.71 176.87"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    y: 151.55,
    width: 239.64,
    height: 72.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.89,187.77c0,6.64-5.38,12.03-12.03,12.03s-12.03-5.38-12.03-12.03,5.38-12.03,12.03-12.03,12.03,5.38,12.03,12.03Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.51,
    y1: 187.77,
    x2: 208.4,
    y2: 187.77
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 581.89,
    y: 207.12,
    width: 72.43,
    height: 239.64,
    transform: "translate(161.5 856.52) rotate(-77.11)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 631.71,
    y: 353.17,
    width: 72.43,
    height: 239.64,
    transform: "translate(-110.35 726.22) rotate(-53.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M609.43,429.43c-3.97,5.33-11.5,6.43-16.83,2.46-5.33-3.97-6.43-11.5-2.46-16.83,3.97-5.33,11.5-6.43,16.83-2.46,5.33,3.97,6.43,11.5,2.46,16.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 625.97,
    y1: 441.75,
    x2: 738.98,
    y2: 525.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 89.35,
    y: 251.21,
    width: 239.64,
    height: 72.43,
    transform: "translate(-39.71 33.61) rotate(-8.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.02,298.07c.97,6.57-3.57,12.68-10.14,13.65-6.57.97-12.68-3.57-13.65-10.14-.97-6.57,3.57-12.68,10.14-13.65,6.57-.97,12.68,3.57,13.65,10.14Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 157.41,
    y1: 295.06,
    x2: 296.8,
    y2: 274.49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417.5,330.8s12.04,19.46-24.15,28.91c-37.12,9.7-55.16,3.08-60.74-1.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M378.58,391.2s45.2-8.05,54.47-22.53c10.35-16.17,2.68-30.47-13.6-40.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M371.51,425.06s26.85-5.08,39.98-14.43c18.07-12.87,20.78-35.72,17.66-35.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M368.54,449.02s14.18-2.9,27.59-10.34,18.82-18.99,15.36-28.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M374.77,318l-51.47,7.93c-24.28,3.74-46.17,16.74-61.09,36.26l-21.04,27.54-139.13,169.36c-10.87,9.45,19.31,12.81,45.73,19.11,0,0,52.43,7.48,65.92-7.57l87.41-97.03s42.7,4.53,74.53-10.36c19.72-9.23,20.51-24.56,20.51-24.56"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 428.14,
    cy: 138.05,
    rx: 134.03,
    ry: 93.09,
    transform: "translate(181.47 514.23) rotate(-74.62)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 421.94,
    cy: 136.34,
    rx: 134.03,
    ry: 86.67,
    transform: "translate(178.56 507) rotate(-74.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.14,487.69l44.08-182.3-45.58-11.01-44.07,182.29,14.12,8.24c9.54,5.57,21.08,6.59,31.45,2.78h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 387.66,
    y1: 304.79,
    x2: 397.4,
    y2: 264.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M422.27,329.35c0-1.19,15.93,9.88,17.46,19.68,3.03,19.41-9.5,22.66-9.5,22.66,0,0,5.17,24.59-18.26,38.89-2.08,1.27,3.99,15.45-15.71,30.33-4.1,3.09.22,15.52-26.48,26.28-39.96,16.1-77.88,5.8-77.88,5.8l26.15-122.8s33.95,17.93,59.53,12.14c35.77-8.09,44.78-20.08,44.68-32.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M410.32,332.72s10.84,17.51-22.27,26.35c-33.96,9.06-50.38,3.21-55.44-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.58,391.2s45.2-8.05,54.47-22.53c10.35-16.17,2.75-34.01-19.4-44.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.51,425.06s26.85-5.08,39.98-14.43c18.07-12.87,20.78-35.72,17.66-35.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.54,449.02s14.18-2.9,27.59-10.34,18.82-18.99,15.36-28.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.77,318l-53.21,8.2c-23.17,3.57-44.06,15.97-58.29,34.6l-22.1,28.93-141.33,171.54c-10.87,9.45,73.16,25.15,110.35,13.77l90.9-101.44s42.7,4.53,74.53-10.36c19.72-9.23,20.51-24.56,20.51-24.56"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 230.24,
    y: 100.01,
    width: 239.64,
    height: 72.43,
    transform: "translate(89.88 -134.71) rotate(24.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.91,105.52c-2.8,6.03-9.95,8.64-15.97,5.85-6.03-2.8-8.64-9.95-5.85-15.97,2.8-6.03,9.95-8.64,15.97-5.85,6.03,2.8,8.64,9.95,5.85,15.97Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 302.61,
    y1: 114.2,
    x2: 430.41,
    y2: 173.51
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M569.52,312.23l3.8.81.57,10.61,5.06-9.19,3.27.7.84,10.45,4.87-9.45,3.8.81-7.01,12.91-4.58-.98-.68-8.88-4.25,7.83-4.58-.98-1.12-14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M589.63,323.72c.91-4.2,4.53-6.52,8.62-5.65,3.79.81,6.13,3.97,5.24,8.14-.11.5-.26,1.01-.46,1.54l-9.96-2.13c-.07,1.68,1.33,3.17,3.09,3.54,1.36.29,2.68-.09,3.85-1.2l2.2,2.51c-1.75,1.88-4.41,2.52-6.84,2.01-4.42-.94-6.58-4.74-5.72-8.76ZM600.25,324.58c.14-1.58-.87-3.02-2.62-3.4s-3.45.46-3.98,1.99l6.6,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M603.21,333.84l4.32-20.21,3.62.77-1.73,8.1c1.15-.96,2.74-1.46,4.95-.98,3.9.83,6.04,4.4,5.14,8.59-.89,4.16-4.31,6.6-8.21,5.77-2.02-.43-3.44-1.47-4.1-2.71l-.38,1.45-3.6-.77ZM611.26,332.41c2.18.47,4.1-.93,4.57-3.11.48-2.23-.71-4.18-2.91-4.64-2.17-.46-4.1.85-4.57,3.05-.47,2.18.73,4.24,2.91,4.71Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M620.47,330.29c.86-4.03,4.8-6.5,8.89-5.62,2.58.55,4.85,2.45,5.56,5.3l-3.18,1.18c-.46-1.77-1.71-2.8-3.05-3.08-2.21-.47-4.11.89-4.58,3.08-.46,2.14.77,4.14,2.88,4.59,1.49.32,2.89-.12,4.18-1.6l2.26,2.43c-1.8,2.24-4.65,3.03-7.24,2.48-4.13-.88-6.58-4.74-5.72-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M633.61,340.34l4.32-20.21,3.69.79-1.69,7.9c.91-.72,2.53-1.29,4.51-.87,3.16.67,4.96,3.25,4.26,6.57l-1.85,8.66-3.69-.79,1.65-7.71c.41-1.91-.59-3.2-2.18-3.54s-3.26.38-3.67,2.29l-1.65,7.71-3.69-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M649.36,336.48c.91-4.2,4.53-6.52,8.62-5.65,3.79.81,6.13,3.97,5.24,8.14-.11.5-.26,1.01-.46,1.54l-9.96-2.13c-.07,1.68,1.33,3.17,3.09,3.54,1.36.29,2.68-.09,3.85-1.2l2.2,2.51c-1.75,1.88-4.41,2.52-6.84,2.01-4.42-.94-6.58-4.74-5.73-8.76ZM659.98,337.34c.14-1.58-.87-3.02-2.62-3.4-1.82-.39-3.45.46-3.98,1.99l6.6,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M663.47,339.48c.86-4.03,4.79-6.5,8.89-5.62,2.58.55,4.85,2.45,5.56,5.3l-3.18,1.18c-.46-1.77-1.71-2.8-3.05-3.08-2.21-.47-4.11.89-4.58,3.08-.46,2.14.77,4.14,2.88,4.59,1.49.32,2.89-.12,4.18-1.6l2.26,2.43c-1.8,2.24-4.66,3.03-7.24,2.48-4.13-.88-6.58-4.74-5.72-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M698.37,332.92c1.25.27,1.94,1.32,1.67,2.58-.27,1.25-1.33,1.92-2.58,1.66-1.25-.27-1.93-1.31-1.66-2.56.27-1.25,1.31-1.94,2.56-1.67ZM692.2,352.85l2.94-13.78,3.69.79-2.94,13.78-3.69-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M697.99,354.09l2.94-13.78,3.5.75-.27,1.61c.92-.81,2.6-1.41,4.65-.97,3.19.68,4.99,3.26,4.28,6.57l-1.85,8.66-3.68-.79,1.65-7.71c.41-1.91-.61-3.21-2.23-3.55-1.62-.35-3.28.38-3.69,2.29l-1.65,7.71-3.68-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M683.54,345.69c-.85-.03-1.7-.12-2.62-.25l-1.02,4.79-3.73-.8,4.52-21.17,3.73.8-1.89,8.85c2.22-1.46,4.82-2.14,7.15-1.64,2.76.59,4.24,2.6,3.73,5.01s-2.66,3.8-6.05,4.27l-3.81.14ZM681.51,342.7c4.92.56,8.11-.11,8.47-1.79.18-.82-.42-1.5-1.56-1.75-1.91-.41-4.65.45-6.61,2.15l-.3,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M686.28,343.32l4.47,9.21-4.55-.97-2.9-6.38"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M539.59,318.31c-1.42-.3-2.63-1.14-3.42-2.35l-2.34-3.61,3.99-2.59,2.34,3.61c.12.19.29.26.42.29s.31.03.5-.09l8.28-5.36,2.59,3.99-8.28,5.36c-1.21.79-2.66,1.05-4.08.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M550.31,328.68l-21.38-4.57c-3.89-.83-6.38-4.68-5.55-8.57l1.87-8.73c.4-1.89,1.52-3.5,3.13-4.55l12.97-8.41c1.62-1.05,3.55-1.4,5.43-1,1.89.4,3.5,1.52,4.55,3.13l8.41,12.97c1.05,1.62,1.4,3.55,1,5.43l-1.87,8.73c-.83,3.89-4.68,6.38-8.57,5.55ZM545.79,297.5c-.64-.14-1.3-.02-1.85.34l-12.97,8.41c-.55.36-.93.91-1.07,1.55l-1.87,8.73c-.28,1.33.57,2.64,1.89,2.92l21.38,4.57c1.33.28,2.64-.57,2.92-1.89l1.87-8.73c.14-.64.02-1.3-.34-1.85l-8.41-12.97c-.36-.55-.91-.93-1.55-1.07Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard001);
export default __webpack_public_path__ + "static/media/Dashboard 001.6ff66b1ef190e53e56823f8a840274dd.svg";
export { ForwardRef as ReactComponent };